export const APOTEKET_MERCHANT_ID = '4f9658237f694282b613a3c95bda04a3';
export const MAD_TEST_HOST = 'https://example.com';
